// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/history/stylesheet/refill.scss
 ** module id = 445
 ** module chunks = 1
 **/